import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly analyticGoals: ReadonlyArray<{ readonly __typename?: 'YalperAnalyticGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> } | null, readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly funnelSettings: { readonly __typename?: 'YalperFunnelSettings', readonly attributionModel: Types.YalperAnalyticAttributionModelEnum }, readonly campaignMediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperCampaignMediaplanStat', readonly campaignId: string, readonly campaignName: string, readonly accountName: string }>, readonly aiMonitoringConfig?: { readonly __typename?: 'AiMonitoringConfig', readonly id: string, readonly status: Types.AiMonitoringStatus, readonly campaignSelectionMode: Types.CampaignSelectionMode, readonly campaignIds?: ReadonlyArray<number> | null, readonly campaignNameMask?: string | null, readonly attributionModel: Types.YalperAnalyticAttributionModelEnum, readonly kpi: Types.AiKpiType, readonly kpiValue: string, readonly budget?: string | null, readonly goals: ReadonlyArray<{ readonly __typename?: 'AiReportGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> } | null } | null } | null };

export type GetAiReportsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAiReportsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly marvinAiReports: ReadonlyArray<{ readonly __typename?: 'MarvinAiReport', readonly marvinReportId?: string | null, readonly companyName?: string | null, readonly reportDate?: string | null, readonly status?: string | null, readonly hasFeedback?: boolean | null, readonly source: Types.AiReportSource }> } | null } | null };

export type GetCurrentUserReportsLimitQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserReportsLimitQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly aiReportsLimit: { readonly __typename?: 'AiReportsLimit', readonly remainingReports?: number | null } } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($companyId: ID, $startDate: Date!, $endDate: Date!) {
  currentUser {
    company(id: $companyId) {
      analyticGoals(companyId: $companyId) {
        id
        name
        counterId
        counterName
      }
    }
    currentCompany {
      funnelSettings {
        attributionModel
      }
      campaignMediaplanStats(startDate: $startDate, endDate: $endDate) {
        campaignId
        campaignName
        accountName
      }
      aiMonitoringConfig {
        id
        status
        campaignSelectionMode
        campaignIds
        campaignNameMask
        goals {
          id
          name
          counterId
          counterName
        }
        attributionModel
        kpi
        kpiValue
        budget
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetAiReportsDocument = gql`
    query GetAiReports {
  currentUser {
    currentCompany {
      marvinAiReports {
        marvinReportId
        companyName
        reportDate
        status
        hasFeedback
        source
      }
    }
  }
}
    `;

/**
 * __useGetAiReportsQuery__
 *
 * To run a query within a React component, call `useGetAiReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiReportsQueryPage, GetAiReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiReportsQueryPage, GetAiReportsQueryVariables>(GetAiReportsDocument, options);
      }
export function useGetAiReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiReportsQueryPage, GetAiReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiReportsQueryPage, GetAiReportsQueryVariables>(GetAiReportsDocument, options);
        }
export function useGetAiReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiReportsQueryPage, GetAiReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiReportsQueryPage, GetAiReportsQueryVariables>(GetAiReportsDocument, options);
        }
export type GetAiReportsQueryHookResult = ReturnType<typeof useGetAiReportsQuery>;
export type GetAiReportsLazyQueryHookResult = ReturnType<typeof useGetAiReportsLazyQuery>;
export type GetAiReportsSuspenseQueryHookResult = ReturnType<typeof useGetAiReportsSuspenseQuery>;
export type GetAiReportsQueryResult = Apollo.QueryResult<GetAiReportsQueryPage, GetAiReportsQueryVariables>;
export const GetCurrentUserReportsLimitDocument = gql`
    query GetCurrentUserReportsLimit {
  currentUser {
    aiReportsLimit {
      remainingReports
    }
  }
}
    `;

/**
 * __useGetCurrentUserReportsLimitQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserReportsLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserReportsLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserReportsLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserReportsLimitQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>(GetCurrentUserReportsLimitDocument, options);
      }
export function useGetCurrentUserReportsLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>(GetCurrentUserReportsLimitDocument, options);
        }
export function useGetCurrentUserReportsLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>(GetCurrentUserReportsLimitDocument, options);
        }
export type GetCurrentUserReportsLimitQueryHookResult = ReturnType<typeof useGetCurrentUserReportsLimitQuery>;
export type GetCurrentUserReportsLimitLazyQueryHookResult = ReturnType<typeof useGetCurrentUserReportsLimitLazyQuery>;
export type GetCurrentUserReportsLimitSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserReportsLimitSuspenseQuery>;
export type GetCurrentUserReportsLimitQueryResult = Apollo.QueryResult<GetCurrentUserReportsLimitQueryPage, GetCurrentUserReportsLimitQueryVariables>;